import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';
import { DepartmentFieldsModel } from '../../type/entities/department-type';

const ENDPOINT = '/departments';

export class DepartmentService extends RestServiceConnection {

    listDepartments = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    listDepartmentsForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-for-select',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getUnassignedDepartments = async (filters: any) => {
        this.response = await this.makeRequest({
            method: 'GET',
            url: '/commercial-network/get-unassigned-departments',
            data: filters,
        }, true);
        return this;
    }

    getDepartmentsByCommercialNetwork = async (commercialNetworkId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: '/commercial-network/get-departments',
            data: { commercialNetworkId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    getDepartmentById = async (departmentId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { departmentId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleDepartmentState = async (departmentId: string, status: boolean) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle',
            data: { departmentId, active: status },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    createDepartment = async (department: DepartmentFieldsModel) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: department,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    editDepartment = async (department: DepartmentFieldsModel) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: department,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    deleteDepartment = async (departmentsId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { departmentsId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    deleteMultiDepartments = async (departmentsId: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { departmentsId }
        }, true);
        return this;
    }

    copyConfiguration = async (departmentId: string, departmentsIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/copy-configuration',
            data: { departmentId, departmentsIds },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

}